var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 5.40001C11.7 6.89118 10.4912 8.10001 9.00002 8.10001C7.50885 8.10001 6.30002 6.89118 6.30002 5.40001C6.30002 3.90884 7.50885 2.70001 9.00002 2.70001C10.4912 2.70001 11.7 3.90884 11.7 5.40001Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 7.20001C16.2 8.19412 15.3941 9.00001 14.4 9.00001C13.4059 9.00001 12.6 8.19412 12.6 7.20001C12.6 6.2059 13.4059 5.40001 14.4 5.40001C15.3941 5.40001 16.2 6.2059 16.2 7.20001Z",
    fill: "#4318FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 13.5C12.6 11.5118 10.9882 9.90001 9.00002 9.90001C7.0118 9.90001 5.40002 11.5118 5.40002 13.5V16.2H12.6V13.5Z",
    fill: "#4318FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40002 7.20001C5.40002 8.19412 4.59413 9.00001 3.60002 9.00001C2.60591 9.00001 1.80002 8.19412 1.80002 7.20001C1.80002 6.2059 2.60591 5.40001 3.60002 5.40001C4.59413 5.40001 5.40002 6.2059 5.40002 7.20001Z",
    fill: "#4318FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 16.2V13.5C14.4 12.5513 14.1554 11.6597 13.7257 10.8849C13.9412 10.8295 14.1672 10.8 14.4 10.8C15.8912 10.8 17.1 12.0088 17.1 13.5V16.2H14.4Z",
    fill: "#4318FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27436 10.8849C3.84469 11.6597 3.60002 12.5513 3.60002 13.5V16.2H0.900024V13.5C0.900024 12.0088 2.10885 10.8 3.60002 10.8C3.83286 10.8 4.05881 10.8295 4.27436 10.8849Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.7c56db741a353314010c9d3644e36322.svg";
export { ForwardRef as ReactComponent };